var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUserSquare(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 15.725,
    height: 15.725,
    viewBox: "0 0 15.725 15.725",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "user-square-svgrepo-com",
    transform: "translate(-2.5 -2.5)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_10619",
    "data-name": "Path 10619",
    d: "M3,10.362C3,4.3,4.3,3,10.362,3s7.362,1.3,7.362,7.362c0,3.526-.44,5.441-2,6.426l-.258-.8a2.928,2.928,0,0,0-1.618-2.041,8.45,8.45,0,0,0-3.486-.518,8.232,8.232,0,0,0-3.488.54,2.985,2.985,0,0,0-1.615,2.059L5,16.791C3.44,15.807,3,13.892,3,10.362ZM7.7,8.726a2.659,2.659,0,1,1,2.659,2.659A2.659,2.659,0,0,1,7.7,8.726Z",
    fill: "#559f82",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10620",
    "data-name": "Path 10620",
    d: "M3,10.362C3,4.3,4.3,3,10.362,3s7.362,1.3,7.362,7.362-1.3,7.362-7.362,7.362S3,16.425,3,10.362Z",
    fill: "none",
    stroke: "#fff",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10621",
    "data-name": "Path 10621",
    d: "M13.908,9.454A2.454,2.454,0,1,1,11.454,7,2.454,2.454,0,0,1,13.908,9.454Z",
    transform: "translate(-1.092 -0.728)",
    fill: "none",
    stroke: "#fff",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10622",
    "data-name": "Path 10622",
    d: "M6,18.454C6.522,16.567,7.865,16,10.908,16s4.386.526,4.908,2.413",
    transform: "translate(-0.546 -2.366)",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeWidth: 1
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUserSquare);
export default __webpack_public_path__ + "static/media/user-square.a966b5dbf4cd890f2af420ba373d750a.svg";
export { ForwardRef as ReactComponent };